import {LangKeyType} from '../../../../../../../provider/locale/translation/type';
import {CatalogPriorityPlacementEnum} from '../../../../../../../service/reivew-analysis/rating-dynamics/reviews-analytics-ratings-dynamic-type';

export const priorityStatusMarkPopoverTitleLangKey: Record<CatalogPriorityPlacementEnum, LangKeyType> = {
    [CatalogPriorityPlacementEnum.PriorityPlacement]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__PRIORITY_PLACEMENT_WGIS_TITLE',
    [CatalogPriorityPlacementEnum.NotPriorityPlacement]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__NOT_PRIORITY_PLACEMENT_WGIS_TITLE',
};

export const priorityStatusMarkPopoverContentLangKey: Record<CatalogPriorityPlacementEnum, LangKeyType> = {
    [CatalogPriorityPlacementEnum.PriorityPlacement]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE_PRIORITY_PLACEMENT_WGIS_CONTENT',
    [CatalogPriorityPlacementEnum.NotPriorityPlacement]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE_PRIORITY_PLACEMENT_WGIS_CONTENT',
};
